import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { MdOutlineNotificationsNone } from 'react-icons/md';
import { IMAGE_BASE_URL } from '../../common/Constants';
import FlooringNotificationCard from './FlooringNotificationCard';

const arrayToObject = (arr) => {
  let finalObj = {};
  arr.forEach((elem, i) => {
    finalObj[`${elem?.id}`] = 'after_update';
  });
  return finalObj;
};

const FlooringNotificationContent = (props) => {
  const { selectedNotification } = props;
  const [commissionSegment, setCommissionSegment] = useState({});


  useEffect(() => {
    if (selectedNotification?.updated_information) {
      setCommissionSegment(
        arrayToObject(selectedNotification.updated_information)
      );
    } else {
      setCommissionSegment({});
    }
  }, [selectedNotification]);

  return (
    <>
      {selectedNotification.data && selectedNotification ? (
        <div className='flex-[1] w-[600px] max-w-full'>
          <div>
            <div className='p-[17px_26px_0px_26px]'>
              <h1 className='font-[600] text-[13px]'>
                {selectedNotification?.reason}
              </h1>
            </div>
            <div className='flex flex-wrap gap-[20px] justify-between items-center p-[17px_26px] pt-[10px] border-b border-[#EAEAEA]'>
              <div className='notf_card_box flex items-center gap-[10px]'>
                <div
                  className='min-[1181px]:hidden'
                  onClick={() => props.notfBar(true)}
                >
                  <MdOutlineNotificationsNone
                    className={`text-[#0560FB] text-[20px]`}
                  />
                </div>
                <div className='h-[45px] w-[45px] overflow-hidden border border-[#DEDEDE] rounded-[6px]'>
                  <img
                    src={`${IMAGE_BASE_URL}${selectedNotification?.data?.logo}`}
                    className='rounded-[8px]'
                    width='58'
                    height='58'
                  />
                </div>
                <div>
                  <h5 className='text-[13px] mb-[2px]'>
                    <b>{selectedNotification?.data?.name}</b>
                  </h5>
                  <p className='text-black text-[13px]'>
                    {selectedNotification?.data?.message}
                  </p>
                </div>
              </div>
              <div className='flex gap-[50px] items-center'>
                <div className='text-[#0D062D] text-[13px] font-[600]'>
                  {moment(selectedNotification?.data?.loginfo?.updated_at)
                    .format('DD MMM YYYY')
                    .toUpperCase()}
                  ,{' '}
                  {moment(
                    selectedNotification?.data?.loginfo?.updated_at
                  ).format('HH:MM') + '   hrs'}
                </div>
                <div></div>
              </div>
            </div>
          </div>
          <div className='flex flex-col gap-5 w-full p-5 bg-secondary'>
            <FlooringNotificationCard
              beforeData={selectedNotification?.product_info?.before}
              afterData={selectedNotification?.product_info?.after}
            />
          </div>
        </div>
      ) : (
        <div className='flex-[1] w-[600px]'>
          <div className='flex justify-between items-center p-[17px_26px] border-b border-[#EAEAEA] mt[300px]'>
            No Preview for Notifications, Please move to case details page
          </div>
        </div>
      )}
    </>
  );
};

export default FlooringNotificationContent;
